import { render, staticRenderFns } from "./select.vue?vue&type=template&id=112ef2bd&scoped=true&"
import script from "./select.vue?vue&type=script&lang=js&"
export * from "./select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112ef2bd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\mzkj\\要炼\\yl-pc-business\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('112ef2bd')) {
      api.createRecord('112ef2bd', component.options)
    } else {
      api.reload('112ef2bd', component.options)
    }
    module.hot.accept("./select.vue?vue&type=template&id=112ef2bd&scoped=true&", function () {
      api.rerender('112ef2bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/trade/setAttr/select.vue"
export default component.exports